<template>
	<div class="error-page-wrapper access-denied">
		<figure>
			<img src="/client/resources/img/error_img.png" alt="error-img">
		</figure>

		<p class="error-type"><span class="accent">403</span>ERROR</p>

		<p class="error-reason">죄송합니다. <span>현재 접근할 수 없는 페이지</span> 입니다<br />권한이 없거나, 권한 정보 조회 오류로 요청하신 페이지로 이동할 수 없습니다.
		</p>

		<div class="button-wrap">
			<button type="button" class="btn" @click="fnGoBack">이전 페이지로</button>
			<button type="button" class="btn" @click="fnMainMove">메인 페이지로</button>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	methods: {
		fnMainMove() {
			this.$router.push({
				path: this.$filters.ctxPath("/"),
			});
		},
		fnGoBack() {
			this.$router.go(-1);
		},
	},
	watch: {},
	computed: {},
	components: {},
	created() {
		console.log('=== notFound created ===');
	},
	mounted() {
		console.log('=== notFound mounted ===');
	},
};
</script>